// extracted by mini-css-extract-plugin
export default {"networkOperatorContainer":"NetworkOperatorCell_networkOperatorContainer__D6JoB","logo":"NetworkOperatorCell_logo__jC+eS","name":"NetworkOperatorCell_name__BdDFi"};